module.exports = __webpack_public_path__ + "img/pr-1.47936367.png";